import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import { motion } from "framer-motion";
import Navigation from "../Navigation";
import Header from "../Header";

const FinalPageComponent = ({
  page,
  setPage,
  userName,
  goals,
  selectedGoalId,
}) => {
    const selectedGoal = goals.find((goal) => goal.id === selectedGoalId);

  return (
    <ViewContainer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Header />
      <Content>
        <TextContent>
          <Text>{userName}, dziękujemy za Twoje odpowiedzi. Każda z nich pomaga nam lepiej Cię zrozumieć i dobrać dla Ciebie pigułki wiedzy, wyzwania, narzędzia.</Text>
          <Text>Pracujemy wspólnie nad:</Text>
          <Text style={{fontWeight: "bold"}}>"{selectedGoal.name}"</Text>
        </TextContent>
        <Navigation
          showBackButton={true}
          showNextButton={true}
          setPage={setPage}
          page={page}
        />
      </Content>
    </ViewContainer>
  );
};

export default FinalPageComponent;

const ViewContainer = styled(motion.div)`
  min-height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const Logo = styled.div`
  display: flex;
  justify-content: center;
`;

const Content = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 0 0 0 0;
`;

const Text = styled.div`
  text-align: center;
  color: #fff;
  font-size: 20px;
  line-height: 35px;
  font-weight: 300;
`;

const SmallText = styled(Text)`
  font-size: 20px;
  line-height: 25px;
`;

const SelectBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  width: 100%;
`;

const growAnimation = keyframes`
 0% { scale: 0.9 }
 100% { scale: 1 }
`;

const SelectBox = styled.div`
  width: 100%;
  background-color: ${(props) =>
    props.isSelected ? "rgba(0, 0, 0, 0.5)" : "rgba(57,56,146,0.8)"};
  padding: 15px;
  border-radius: 15px;
  text-align: center;
  color: #fff;
  font-size: 17px;
  font-weight: 300;
  transition: all 0.2s;
  animation: ${growAnimation} 0.5s ease;

  &:active {
    transform: scale(0.97);
  }
`;

const SliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;

  input {
    width: 80%;
    margin-bottom: 10px;
  }
`;

const SliderValue = styled.div`
  color: #fff;
  font-size: 16px;
`;